import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

class Controls {
    instance: any
    constructor( camera, canvas ) {
        this.instance = new OrbitControls( camera, canvas );
        this.instance.minDistance = 0.7
        this.instance.maxDistance = 7
    }
}

export default Controls
